export const translations = {
  titulo: {
    pt: "E-mails dos responsáveis",
    en: "Responsible emails",
    es: "Correos electrónicos responsables",
    de: "Verantwortliche E-Mails",
  },
  email: {
    pt: "E-mail",
    en: "Email",
    es: "Correo electrónico",
    de: "E-Mail",
  },
  adicionar: {
    pt: "Adicionar",
    en: "Add",
    es: "Agregar",
    de: "Hinzufügen",
  },
  obrigatorio: {
    pt: "Obrigatório",
    en: "Mandatory",
    es: "Obligatorio",
    de: "Pflichtfeld",
  },
  emailInvalido: {
    pt: "E-mail inválido",
    en: "Invalid email",
    es: "Correo electrónico inválido",
    de: "Ungültige E-Mail",
  },
  placeholder: {
    pt: "Digite o e-mail do responsável",
    en: "Type the responsible email",
    es: "Ingrese el correo electrónico responsable",
    de: "Geben Sie die verantwortliche E-Mail ein",
  },
  vazio: {
    pt: "Nenhum e-mail responsável cadastrado.",
    en: "No responsible email registered.",
    es: "No hay correo electrónico responsable registrado.",
    de: "Keine verantwortliche E-Mail registriert.",
  },
};
